export default __webpack_public_path__ + "static/media/eth.66ca8398.png";